import type { DirectoryEntry } from "./resource-sharing"

export function entryKey({ kind, id }: DirectoryEntry): string {
  return `${kind}:${id}`
}
